const createMarkup = description => {
  return { __html: description };
};
export default createMarkup;
